import Select from "@/common/components/Select";
import { useCities } from "@/common/hooks/queries/useCities";
import useDebounce from "@/common/hooks/useDebounce";
import { GeoTransformers } from "@/common/services/geoTransformers";
import { Mapper } from "@/common/services/mapper";
import { DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterCityHiddenFilter = ({
  value,
  onChange,
}: DashboardHiddenFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: cityOptions,
  } = useCities({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: GeoTransformers.optionsTransformer()
    }),
  });

  return (
    <Select
      label="Selecione a cidade"
      markAsRequired
      options={cityOptions}
      onInputChange={setSearch}
      value={value}
      onChange={onChange}
    />
  );
}

export default DashboardFilterCityHiddenFilter;
